module.exports = __webpack_public_path__ + "static/media/provider-photo-hospitals.697bed2d.jpg";